
import * as React from 'react';
import * as PropTypes from 'prop-types'

import * as api from '../../../store/apiClient';
import * as auth from '../../../utils/auth';
import { clickHandler } from '../../../utils/util';
import { CustomerDeletionInfo } from '../../../store/pages/customer/customerApi';
import { DateFormat } from '../../../store/pages/venues/types';
import Loading from '../../global/loading';
import ConfirmReinstateCustomer from './confirmReinstateCustomer';

interface DeletedCustomerDetailsProps {
    customerId: string;
    deletionInfo?: CustomerDeletionInfo;
    dateFormat: DateFormat;
    showModal: (overlayComponent: JSX.Element, screenName: string) => void;
    closeModal: () => void;
    onReinstated: () => void;
    close: () => void;
}

interface DeletedCustomerDetailsState {
    loading: boolean;
    details: CustomerDeletionInfo | null;
}

class DeletedCustomerDetails extends React.Component<DeletedCustomerDetailsProps, DeletedCustomerDetailsState> {

    constructor(props: DeletedCustomerDetailsProps) {
        super(props);
        this.state = { loading: !props.deletionInfo, details: props.deletionInfo ?? null };
    }

    static contextTypes = {
        t: PropTypes.func
    }

    componentDidMount() {
        const { customerId, deletionInfo } = this.props;
        if (deletionInfo)
            return;

        api.getJson<CustomerDeletionInfo>(`api/v1/customer/${customerId}/deletion`)
            .subscribe(d => this.setState({ loading: false, details: d }), _ => this.setState({ loading: false }));
    }

    reinstate = () => {
        const { customerId, showModal, closeModal, onReinstated } = this.props;
        const { details } = this.state;

        const close = (reinstated: boolean) => {
            closeModal();
            if (reinstated) {
                onReinstated();
            }
        };

        showModal(<ConfirmReinstateCustomer customerId={customerId} firstname={details?.firstname} lastname={details?.lastname} close={close} />, 'ConfirmReinstateCustomer');
    }

    render() {
        const { dateFormat } = this.props;
        const { loading, details } = this.state;
        const { t } = this.context;

        return (
            <div>
                <h3>{t('DeletedCustomerDetails:heading')}</h3>

                {loading ? <Loading /> :
                    <div>
                        {details ?
                            <div>
                                <div className='alert alert-warning'>{t('DeletedCustomerDetails:message', { removalDate: new Date(details.scheduledPurgeDate).toShortDateString(dateFormat) })}</div>

                                <div className='row mt-15'>
                                    <div className='col-md-12'>
                                        <label>{t('DeletedCustomerDetails:customerName')}</label>
                                        <div>{details.firstname} {details.lastname}</div>
                                    </div>
                                </div>
                                <div className='row mt-15'>
                                    <div className='col-md-12'>
                                        <label>{t('DeletedCustomerDetails:emailAddress')}</label>
                                        <div>{details.emailAddress}</div>
                                    </div>
                                </div>
                                <div className='row mt-15'>
                                    <div className='col-md-12'>
                                        <label>{t('DeletedCustomerDetails:deletedBy')}</label>
                                        <div>{details.deletedBy}</div>
                                    </div>
                                </div>
                                <div className='row mt-15'>
                                    <div className='col-md-12'>
                                        <label>{t('DeletedCustomerDetails:whenDeleted')}</label>
                                        <div>{new Date(details.whenDeleted).toShortDateString(dateFormat)}</div>
                                    </div>
                                </div>
                                <div className='row mt-15'>
                                    <div className='col-md-12'>
                                        <label>{t('DeletedCustomerDetails:scheduledPurge')}</label>
                                        <div>{new Date(details.scheduledPurgeDate).toShortDateString(dateFormat)}</div>
                                    </div>
                                </div>
                            </div>
                            : null}

                        <div className='mt-15 btn-toolbar'>
                            {auth.isSystemAdmin() ? <button className='btn btn-primary' onClick={e => clickHandler(e, this.reinstate)}>{t('DeletedCustomerDetails:reinstate')}</button> : null}
                            <button className='btn btn-basic' onClick={e => clickHandler(e, this.props.close)}>{t('Global:close')}</button>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default DeletedCustomerDetails;
